import { ExportFormats } from "common/ExportFormats";
import { ModalOverlay } from "common/styleguide/ModalOverlay";
import { contentLabel } from "lib/styleguide/base.scss";
import React from "react";
import { FormattedMessage as T } from "react-intl";
import styles from "./ExportTRouteModal.scss";

export const EXPORT_TROUTE_MODAL = "EXPORT_TROUTE_MODAL";

export const ExportTRouteModal = ({ troute, objectType, onRequestClose }) => (
  <ModalOverlay
    title={
      <span>
        <T
          id="ExportTRouteModal.exportName"
          defaultMessage="Export <strong>{name}</strong>"
          values={{
            strong: (...c) => <strong>{c}</strong>,
            name: troute.name,
          }}
        />
      </span>
    }
    maxWidth="400px"
    onRequestClose={onRequestClose}
  >
    <div className={styles.ExportTRouteModal}>
      <h2 className={contentLabel} style={{ marginBottom: "15px" }}>
        <T id="ExportTRouteModal.fileFormats" defaultMessage="File Formats" />
      </h2>
      <div style={{ marginBottom: "40px" }}>
        <ExportFormats troute={troute} objectType={objectType} />
      </div>
      <p className={styles.help}>
        <T
          id="ExportTRouteModal.notSureFormat"
          defaultMessage="Not sure which format you need? Our <a>help page</a> has detailed information about compatibility with a variety of programs and devices"
          values={{
            a: (...c) => (
              <a href="https://ridewithgps.com/help/export-file-formats" target="_blank">
                {c}
              </a>
            ),
          }}
        />
      </p>
    </div>
  </ModalOverlay>
);
